/*
 * @File index.js
 * @Description This File is for attributes store module
 */
import state from '@/store/modules/attributes/state'
import mutations from '@/store/modules/attributes/mutations'
import actions from '@/store/modules/attributes/actions'
import getters from '@/store/modules/attributes/getters'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
